import type { SVGProps } from 'react';
import { useId } from 'react';

const OfficialIcon = (props: SVGProps<SVGSVGElement>) => {
  const gradientId = useId();
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        display: 'inline-block',
      }}
      {...props}
    >
      <path
        d="M10.0004 1.14062C10.4547 1.14068 10.9088 1.31458 11.2553 1.66113L12.8579 3.2627H15.0688C16.0493 3.26274 16.8441 4.05773 16.8442 5.03809V7.24902L18.3696 8.77441C19.0627 9.46762 19.0626 10.5919 18.3696 11.2852L16.8442 12.8105V15.0986C16.8441 16.079 16.0492 16.874 15.0688 16.874H12.7807L11.2553 18.3984C10.9088 18.745 10.4547 18.9189 10.0004 18.9189C9.54604 18.9189 9.09116 18.7451 8.74459 18.3984L7.22018 16.874H5.00826C4.02806 16.8738 3.23299 16.0789 3.23287 15.0986V12.8877L1.63131 11.2852C0.938025 10.5919 0.937978 9.4677 1.63131 8.77441L3.23287 7.17285V5.03809C3.23299 4.05784 4.02807 3.26287 5.00826 3.2627H7.14303L8.74459 1.66113C9.0912 1.3145 9.54608 1.14062 10.0004 1.14062ZM6.70064 7.1123C6.33467 7.11264 6.10257 7.5038 6.27779 7.8252L9.68697 14.0762C9.86989 14.4111 10.3507 14.411 10.5337 14.0762L13.9438 7.8252C14.1188 7.50375 13.886 7.11241 13.52 7.1123H12.52C12.3372 7.1123 12.1701 7.21543 12.0883 7.37891L10.5424 10.4707C10.3646 10.8264 9.85699 10.8264 9.67916 10.4707L8.13228 7.37891C8.05062 7.21557 7.88421 7.11249 7.70162 7.1123H6.70064Z"
        fill={`url(#${gradientId})`}
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="10.0004"
          y1="1.14062"
          x2="10.0004"
          y2="18.9189"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFCE64" />
          <stop offset="1" stopColor="#FF9D00" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default OfficialIcon;
